module.exports = __webpack_public_path__ + "img/license-frontup.01a26b0f.png";